import { toast } from "react-toastify"
import client from "../apollo/client"
import { STRIPE_SESSION } from "../apollo/queries"
import { setUserPlan, setupServicesUser } from "../refactored-functions/user"

export const updateSelectedUpgrade = data => {
  Object.keys(data).forEach(x => {
    console.log(`Updated key ${x} with value ${data[x]}`)
  })
  client.writeData({
    data: { selectedUpgradePlan: `plan-${data.selected_plan}` },
  })
}

export const initUpgradeCheckout = async plan => {
  let sessionId
  const stripe = window.Stripe(`${process.env.GATSBY_STRIPE_KEY}`)
  const response = await client.query({
    query: STRIPE_SESSION,
    fetchPolicy: "network-only",
    variables: {
      planId: `plan-${plan}`,
      redirectURI: window.location.origin,
    },
  })
  if (response && response.data) {
    sessionId = response.data.sessionId
  }

  if (!sessionId) {
    toast.error(
      "There was an issue while checking out.  This probably temporary.  Please refresh the page and try again, or contact support with the blue button on the bottom right."
    )
    console.log("TCL: `STRIPE_SESSION` response", response.data)
    console.error(
      "Stripe.redirectToCheckout failed because the `STRIPE_SESSION` query produced an error."
    )
  } else {
    toast("Thank you! Redirecting you to Stripe Secure Checkout...")
    setTimeout(() => {
      stripe
        .redirectToCheckout({
          sessionId,
        })
        .then(function() {
          // has been successfully redirected...
        })
        .catch(error => {
          toast.error(
            "There was an issue during the redirect.  This probably temporary.  Please refresh the page and try again, or contact support with the blue button on the bottom right."
          )
          console.log(
            `TCL: Error result during redirectToCheckout with session ID (${sessionId})`,
            error
          )
          console.error(error)
        })
    }, 2500)
  }
}

/**
 * Sets the user to the plan selected during the checkout
 * process, which is cached in state.  This function is only
 * called when a user returns from Stripe checkout redirect
 *  to the checkout success URL (/a/settings#upgrade-success)
 */
export const setUserToPurchasedPlan = plan => {
  setUserPlan()
  setupServicesUser()
}
